import React, { useEffect, useState } from "react";

const Disclaimer = () => {
  const [isVisible, setIsVisible] = useState(true);

  const handleClick = () => {
    setIsVisible(false);
  };
  useEffect(() => {
    if (isVisible) {
      document.body.classList.add("overflow-hidden");
    } else {
      document.body.classList.remove("overflow-hidden");
    }
  }, [isVisible]);
  return (
    isVisible && (
      <div className="min-h-screen fixed inset-0  z-[1000] bg-body-bg flex justify-center items-center">
        <div className="xl:max-w-[1165px] px-5 container xl:px-0 mx-auto">
          <div className="bg-white border-[16px] xl:px-0 md:px-10 sm:px-7 px-5 border-light-purple rounded-28 lg:py-[104px] md:py-16 sm:py-14 py-12">
            <h4 className="text-center pb-4 text-dark-purple leading-100 2xl:text-6xl md:text-5xl text-custom-5xl">
              Disclaimer
            </h4>
            <div className="max-h-[180px] md:max-h-[150px] lg:max-h-[120px] xl:max-h-[unset] overflow-auto">
              <p className="max-w-[765px] mx-auto text-center font-roboto xl:pe-0 pe-4 font-medium text-xl leading-150 text-dark-purple">
                I confirm that I am not a citizen of Afghanistan, Benin, Bhutan,
                Bahrain, Egypt, Kuwait, China, Crimea region, Cuba, Iran, Iraq,
                Saudi Arabia, Syria, Oman, UAE, USA, Vatican City, or for use by
                any person in any country or jurisdiction where such
                distribution or use would be contrary to local law or
                regulation.
              </p>
              <p className="max-w-[765px] mx-auto text-center pt-4 font-roboto font-medium text-xl leading-150 text-dark-purple">
                This website is not intended for use by residents of the United
                States. By accessing this site, you confirm that you are not a
                U.S. resident and that you are not using a VPN or any other
                method to disguise your location.
              </p>
            </div>
            <div className="flex justify-center items-center">
              <button
                onClick={handleClick}
                className="text-center shadow-roadmapArrowShadow hover:shadow-none hover:translate-y-2 transition-all duration-300 ease-in-out text-white font-normal sm:text-custom-4xl text-2xl leading-100 [text-shadow:2px_2px_0px_#000] mx-auto mt-10 py-6 px-[43px] border-2 bg-light-purple rounded-18 border-dark-purple"
              >
                Confirm and go to website
              </button>
            </div>
          </div>
        </div>
      </div>
    )
  );
};

export default Disclaimer;
